import React, {useMemo} from "react";
import BootstrapTable from "react-bootstrap-table-next";
import {Card} from 'react-bootstrap';
import paginationFactory, {PaginationProvider} from "react-bootstrap-table2-paginator";
import * as uiHelpers from "./ui.helpers";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
} from "../../../../_metronic/_helpers";
import {Pagination} from "../../../../_metronic/_partials/controls";
import {useOrdersUIContext} from "../../../contexts/OrdersUIContext";

export function OrdersTable(props) {
  const context = useOrdersUIContext();
  const {orderList, totalCount, listLoading} = props;
  const {defaultSorted, columns, sizePerPageList} = uiHelpers;

  const {
    queryParams,
    setQueryParams,
    onClick,
  } = useMemo(() => ({
    queryParams: context.queryParams,
    setQueryParams: context.setQueryParams,
    onClick: (_, row) => context.openOrderDetailDialog(row.ordNo),
  }), [context]);

  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: sizePerPageList,
    sizePerPage: queryParams.pageSize,
    page: queryParams.pageNumber,
  };

  return (
    <Card>
      <Card.Body>
        <PaginationProvider pagination={paginationFactory(paginationOptions)}>
          {({paginationProps, paginationTableProps}) => (
            <Pagination isLoading={listLoading} paginationProps={paginationProps}>
              <BootstrapTable
                remote
                bootstrap4
                hover
                keyField="no"
                bordered={false}
                columns={columns}
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden table-responsible"
                data={orderList === null ? [] : orderList}
                defaultSorted={defaultSorted}
                noDataIndication={<NoRecordsFoundMessage entities={orderList}/>}
                onTableChange={getHandlerTableChange(setQueryParams)}
                rowEvents={{ onClick }}
                {...paginationTableProps}
              />
            </Pagination>
          )}
        </PaginationProvider>
      </Card.Body>
    </Card>
  );
}
